import type { ServerColDef, ValueFormatterParams } from '@cmg/data-grid';
import defaultTo from 'lodash/defaultTo';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export function valueFormatter({ data }: ValueFormatterParams<UnderwriterEmployeeFragment>) {
  return defaultTo(data?.userAccount?.email, '-');
}

const accountEmailColDef: ServerColDef<UnderwriterEmployeeFragment> = {
  field: 'userAccount.email',
  headerName: 'Account Email',
  valueFormatter,
  minWidth: 220,
};

export default accountEmailColDef;
